/**
*  V2.0
*  列表table公共组件:支持多选
*  @author shaochj 2017-03-08
*  @params columns--列数组，dataSource--data，border--带边框表格
*  mulSelectFixed 多选框是否固定
*  buttonClick--表格行按钮点击事件，通过按钮类型进行区分,
*  支持自定义渲染el-table-column
*/
<template>
    <el-row>
        <el-col :span="24" class="list-table">
            <el-table
                    ref="hhtListTable"
                    :data="dataSource"
                    :key="tableKey"
                    style="width: 100%"
                    :height="tabHeight"
                    @sort-change="sortChange"
                    @row-click="rowClick"
                    :min-height="minHeight"
                    :max-height="maxHeight"
                    :border="border"
                    :stripe="stripe"
                    :highlight-current-row="highlightCurrentRow"
                    @current-change="currentRowChange"
                    @selection-change="selectionChange"
                    :default-sort = "defaultSort"
                    :row-class-name="tableRowClassName?tableRowClassName:selfTableRowClassName">
                <!--支持多选 col-->
                <div v-if="mulSelect">
                    <el-table-column
                            type="selection"
                            :selectable="selectable"
                            :fixed="mulSelectFixed"
                            width="55">
                    </el-table-column>
                </div>
                <slot v-for="(column,colIndex) in columns" :name="column.code">
                    <el-table-column
                            :key="column.id"
                            :fixed="column.fixed"
                            :prop="column.code"
                            :label="column.label"
                            :sortable="column.sortable"
                            :min-width="column.minWidth"
                            :width="column.width">
                        <template slot-scope="scope">
                            <!--按钮类型-->
                            <div v-if="column.type == 'button'">
                                <el-button  @click="opt.clickEvent?opt.clickEvent(scope.row,opt.param):buttonClick(scope.row,opt)"
                                            :type="opt.type" :size="opt.size"
                                            v-for="(opt,index) in column.opts" v-if="opt.btnType!='more'" :key="index">{{opt.name}}</el-button>

                                <el-dropdown @command="opt.clickEvent?opt.clickEvent(scope.row,opt.param,$event):buttonClick(scope.row,opt,$event)" v-for="(opt,index) in column.opts" v-if="opt.btnType === 'more'" :key="index">
                                    <span class="el-dropdown-link">{{opt.name}}<i class="el-icon-caret-bottom el-icon--right"></i></span>
                                    <el-dropdown-menu slot="dropdown">
                                        <el-dropdown-item v-for="item in opt.dropdownItems" :command="item.command" :key="item.param">{{item.name}}</el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>
                            </div>
                            <!--链接类型-->
                            <div v-else-if="column.type == 'link'" class="name-link">
                                <!-- <a  :href="column.url+'/'+scope.row.id" >{{scope.row[column.code]}}</a>-->
                                <a href="javascript:void(0)" @click="column.clickEvent?column.clickEvent(scope.row):buttonClick(scope.row,column.type)" >{{scope.row[column.code]}}</a>
                            </div>
                            <!--链接类型-->
                            <div v-else-if="column.type == 'href'" class="name-href">
                                <span @click="column.clickEvent?column.clickEvent(scope.row):buttonClick(scope.row,column.type,column.code)" >{{scope.row[column.code]}}</span>
                            </div>
                            <!--序号-->
                            <div class="col-num" v-else-if="column.type == 'num'">
                                <span>{{(scope.$index)+1}}</span>
                            </div>
                            <div v-else-if="column.type == 'enum'">
                            <span v-for="val in column.formatVal">
                                <span v-if="scope.row[column.code] == val.value">{{val.label}}</span>
                            </span>
                            </div>
                            <!--money千分位-->
                            <div v-else-if="column.type == 'money'">
                            <span>
                                {{moneyToThousands(scope.row[column.code])}}
                            </span>
                            </div>
                            <div v-else-if="column.type == 'mulLine'">
                                <span v-for="line in scope.row[column.detailPropty]" class="detail-line">
                                    <div v-if="column.detailType == 'enum'">
                                        <span v-for="val in column.formatVal">
                                            <span v-if="line[column.code] == val.value">{{val.label}}</span>
                                        </span>
                                    </div>
                                    <div v-else>
                                        {{line[column.code] || line[column.code]==0 ? line[column.code]:'　'}}
                                    </div>
                                </span>
                               <!-- <span>{{(scope.$index)+1}}</span>-->
                            </div>
                            <div v-else class="cell-font-overflow">
                                <!--<el-tooltip :content="scope.row[column.code]" placement="top">
                                    <span v-text="scope.row[column.code]"></span>
                                </el-tooltip>-->
                                <span :title="scope.row[column.code]">{{scope.row[column.code]}}</span>
                            </div>
                        </template>
                    </el-table-column>
                </slot>
            </el-table>
        </el-col>
        <el-col class="table-bottom-page" :span="24" v-if="pagination && pagination.totalSize>0" :style="{textAlign: pagination.position}">
            <bottom-page :pagination="pagination"
                         v-on:currentChange="handleCurrentChange"
                         v-on:sizeChange="handleSizeChange"></bottom-page>
        </el-col>
    </el-row>
</template>
<script>
    import BottomPage from '../../pub/components/BottomPage.vue';
    import mainUtil from '../../../pub/utils/mainUtil';
    export default {
        components:{
            BottomPage:BottomPage,
            ListColumn:{
                render(h){
                    var parent = this.$parent;
                    return
                }
            }
        },
        props:{
            border:Boolean,
            mulSelect:Boolean,
            mulSelectFixed:String,
            selectable: Function,
            highlightCurrentRow:Boolean,//高亮显示选中的行
            columns:Array,
            dataSource:Array,
            pagination:Object,
            tableRowClassName:Function,
            defaultSort:Object,
            showSummary:Boolean,
            minHeight:Number,
            maxHeight:Number,
            height:Number,
            isCalHeight:{
                default:true,
                type:Boolean
            },
            extHeight:{
                default:140,
                type:Number
            },
            extTreeHeight:{
                default:40,
                type:Number
            },
            tableKey:String,
            stripe:{
                default:true,
                type:Boolean
            }
        },

        data:function() {
             return {
                 tabHeight:this.height
             }
         },

        watch:{
            /*tabHeight:{
                immediate: true,
                handler: function (v, oldv) {
                    if(v>0){
                        this.height = v;
                    }
                }
            }*/
        },

        created:function () {
            var _self = this;
            if(_self.isCalHeight && _self.pagination){
                _self.$nextTick(function () {
                    _self.setDivHeight();
                });
                window.onresize = function () {
                    _self.setDivHeight();
                };
            }
        },

        methods: {
            /**
             * 供外部组件调用
             * 自适应高度方法
             */
            calTableHeight:function () {
                var _self = this;
                _self.$nextTick(function () {
                    _self.setDivHeight();
                });
                window.onresize = function () {
                    _self.setDivHeight();
                };
            },
            /**
             * 计算div的高度
             */
            setDivHeight:function () {
                var _self = this;

                if(_self.isCalHeight){
                    window.calCardHeight();
                    var cardHeight = sessionStorage.getItem('listCardHeight');
                    /*var elCards = document.getElementsByClassName("el-card");
                    if(elCards && elCards.length>0){
                        for(var i=0;i<elCards.length;i++){
                            elCards[i].style.height = cardHeight+'px';
                        }
                    }*/
                    _self.tabHeight = parseInt(cardHeight) - _self.extHeight;
                    _self.calElTreeHeight();
                }
            },
            /**
             * 计算列表页面左侧树的高度
             */
            calElTreeHeight:function () {
                var _self = this;
                var treeHeight = _self.tabHeight+_self.extTreeHeight;
                var listTrees = document.getElementsByClassName("cal-size-list-tree");
                if(listTrees && listTrees.length>0) {
                    for(var i=0;i<listTrees.length;i++){
                        listTrees[i].style.height = treeHeight + 'px';
                    }
                }
                var elTrees = document.getElementsByClassName("el-tree");
                if(elTrees && elTrees.length>0){
                    for(var i=0;i<elTrees.length;i++){
                        elTrees[i].style.height = treeHeight+'px';
                    }
                }
            },

            selfTableRowClassName(row, index) {
                if ((!this.stripe) && ((index+1)%2 === 0)) {
                    return 'positive-row';
                }
                /*else if ((index+1)%4 === 0) {
                    return 'positive-row';
                }*/
                return '';
            },

            /**
             * 多选事件
             * @param val--对应项的对象
             */
            selectionChange:function(val){
                this.$emit('selectionChange',val);
            },
            handleCurrentChange:function(val) {

                this.$emit('currentChange',val);
            },
            handleSizeChange:function (val) {
//                console.log('val===',val);
                this.$emit('sizeChange',val);
            },
            currentRowChange:function(row){
                this.$emit('currentRowChange',row);
            },
            /**
             * 按千分位格式化金额
             * @param val
             * @returns {*|string}
             */
            moneyToThousands:function (val) {
                return mainUtil.toThousands(val);
            },
            /**
             * table 按钮点击事件
             * @param rowdata
             * @param btn
             * @param command
             */
            buttonClick:function (rowdata, btn,command) {
                this.$emit('buttonClick',rowdata, btn,command);
            },
            /**
            *设置默认选中事件
            */
            defaultCheckedRows:function(row){
                var _self = this;
                if (row) {
                    if(_self.$refs.hhtListTable){
                        _self.$refs.hhtListTable.toggleRowSelection(row);
                    }
                } else {
                  _self.$refs.hhtListTable.clearSelection();
                }
            },
            /**
            * table 排序事件
             * @param column
             * @param prop
             * @param order
            */
            sortChange:function(column,prop,order){
                this.$emit("sortChange",column,prop,order);
            },
            /**
             * 行点击事件
             * @param row
             * @param event
             * @param column
             */
            rowClick:function (row, event, column) {
//                console.log(row,event, column);
                this.$emit("rowClick",row,event,column);
            }
        }
    }
</script>
<style>

    @import "../styles/listtable.css";
</style>



// WEBPACK FOOTER //
// src/components/pub/components/ListTable.vue